/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Auth } from 'app/scripts/db/auth';
import { BoardSelectOrganizationView } from 'app/scripts/views/board-menu/BoardSelectOrganizationView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
const { View } = require('app/scripts/views/internal/view');
import popoverBoardHeaderOrgMenu from 'app/scripts/views/templates/popover_board_header_org_menu';
import { dontUpsell } from '@trello/browser';
import { Analytics } from '@trello/atlassian-analytics';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { BoardHeaderOrgMenuPopoverButton } from 'app/src/components/UpgradePathAudit';
import { Organization } from 'app/scripts/models/organization';
import { PopoverBoardHeaderOrgMenuTemplateData } from 'app/scripts/views/templates/popover_board_header_org_menu.types';

class BoardHeaderOrgMenuView extends View {
  static initClass() {
    this.prototype.events = {
      'click .js-change-org': 'openChangeOrg',
      'click .js-view-org': 'viewOrg',
    };
  }

  initialize() {
    super.initialize(...arguments);

    this.makeDebouncedMethods('render');

    const org = this.model.getOrganization() as Organization | undefined;

    if (org) {
      this.listenTo(org, {
        'change:products': this.renderDebounced,
      });
    }
  }

  getViewTitle() {
    return this.model.getOrganization()?.get('displayName');
  }

  render() {
    const org = this.model.getOrganization() as Organization | undefined;

    const data = org?.toJSON();

    const userOwnsBoard = this.model.owned();
    const userIsAdminInPaidWorkspace =
      org?.owned() && org?.getPaidStatus() !== 'free';

    const isPremiumBoard = this.model.isBcBoard();
    const isStandardBoard = this.model.isStandardBoard();
    // org/workspace admins are admins of the workspace and board
    // in this case, the user are not admins of the workspace and board
    const isNotOrgAdmin = !(org?.owned() && this.model.owned());

    const isStandardAndNonAdmin = isStandardBoard && isNotOrgAdmin;

    const popoverData: PopoverBoardHeaderOrgMenuTemplateData = {
      canChangeOrg: userOwnsBoard || userIsAdminInPaidWorkspace,
      skipReactRender: isStandardAndNonAdmin || isPremiumBoard || isNotOrgAdmin,
      isOrgMember: Boolean(org?.isMember(Auth.me())),
      upsellEnabled: !dontUpsell(),
      name: data?.name || '',
    };

    this.$el.html(popoverBoardHeaderOrgMenu(popoverData));

    Analytics.sendScreenEvent({
      name: 'boardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
    });

    this.renderUpsellComponent(org?.get('id') || '');

    return this;
  }

  renderUpsellComponent(orgId: string) {
    const container = this.$('#upgrade-path-react-component')[0];

    if (!orgId || !container) {
      return;
    }

    renderComponent(
      <BoardHeaderOrgMenuPopoverButton orgId={orgId} />,
      container,
    );
  }

  openChangeOrg(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);

    PopOver.pushView({
      view: BoardSelectOrganizationView,
      options: {
        model: this.model,
        modelCache: this.modelCache,
      },
    });

    Analytics.sendClickedLinkEvent({
      linkName: 'changeBoardWorkspaceLink',
      source: 'boardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
    });
  }

  viewOrg() {
    return Analytics.sendClickedLinkEvent({
      linkName: 'viewWorkspaceLink',
      source: 'boardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
    });
  }
}

BoardHeaderOrgMenuView.initClass();
export { BoardHeaderOrgMenuView };
